import { ExtendedDosageStagesList } from '~libs.desktop.shared.medicine';
import { ExtendedDosage } from '~libs.shared.prescription';

import { prescriptionTranslationKeys } from '../../../../../translations';
import { StyledPrescriptionTextView } from '../../prescriptionTextView.styled';

type ExtendedDosageStagesTextViewProps = {
   readonly stages: ExtendedDosage['stages'];
   readonly portionUnit: string | null;
};

export const ExtendedDosageStagesTextView = (props: ExtendedDosageStagesTextViewProps): JSX.Element => {
   return (
      <StyledPrescriptionTextView
         testId={'extendedDosage'}
         compact
         label={prescriptionTranslationKeys.dosage.extendedDosage}
      >
         <ExtendedDosageStagesList stages={props.stages} portionUnit={props.portionUnit} />
      </StyledPrescriptionTextView>
   );
};
